// internal URI spitter method - direct from RFC 3986
var splitUri = function splitUri(uri) {
  var splitted = uri.match(/(?:([^:/?#]+):)?(?:\/\/([^/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
  return splitted;
};

/**
 * @param {string} url
 * @returns boolean - true if the url is valid
 */
export function validateURL(url) {
  // to maintain consistency across browsers, we consider the url to be invalid
  // if it contains any white-space characters that are not encoded
  if (url.trim().search(/\s/g) > -1) {
    return false;
  }
  try {
    var givenURL = new URL(url.trim());
    var splitted = splitUri(givenURL.href) || [];
    var scheme = splitted[1] || '';
    var authority = splitted[2] || '';

    // if an authority is present, it requires a "//"
    // https://www.loc.gov/standards/uri/generic.html
    if (authority && authority.length) {
      var indexAfterScheme = url.indexOf(scheme) + scheme.length + 1;
      var substringUrl = url.substring(indexAfterScheme);

      // check if // is present
      if (!substringUrl.startsWith('//')) {
        return false;
      }
    }
  } catch (error) {
    return false;
  }
  return true;
}